import homepage from "../../assets/homepage.png";

const Home = () => {
    return(<>
      <h1>Home</h1>
      <div class="home">
        <h1> Welcome to Sandra Sanders Portfolio</h1>
        <img src={homepage} width="80%" ></img>

      </div>
    </>)
    
  }
  
  
  export default Home;